// WELCOME MESSAGE ANIMATION
document.querySelector('.dashAssign-message')?.removeAttribute('hidden');
document.querySelector('.dashAssign-message .uk-alert-close')?.addEventListener('click', (event) => {
  event.preventDefault();
  event.target.closest('.dashAssign-message').setAttribute('hidden', '')
})